module.exports = __webpack_public_path__ + "static/media/chiapas_flordechaiapas_trigosuave_10.0ec50872.png";